<template>
  <div class="fixed inset-0 z-40 flex">
    <TransitionChild as="template" enter="transition-opacity ease-linear duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="transition-opacity ease-linear duration-300" leave-from="opacity-100" leave-to="opacity-0">
      <DialogOverlay class="fixed inset-0 bg-gray-600 bg-opacity-75" />
    </TransitionChild>
    <TransitionChild as="template" enter="transition ease-in-out duration-300 transform" enter-from="-translate-x-full" enter-to="translate-x-0" leave="transition ease-in-out duration-300 transform" leave-from="translate-x-0" leave-to="-translate-x-full">
      <div class="relative max-w-xs w-full bg-indigo-50 pt-5 pb-4 flex-1 flex flex-col">
        <TransitionChild as="template" enter="ease-in-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in-out duration-300" leave-from="opacity-100" leave-to="opacity-0">
          <div class="absolute top-1 right-0 -mr-14 p-1">
            <button type="button" class="h-12 w-12 rounded-full flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-white" @click="sendCloseMobileMenuEvent">
              <XIcon class="h-6 w-6 text-white" aria-hidden="true" />
              <span class="sr-only">{{ $t('app.closeSidebar') }}</span>
            </button>
          </div>
        </TransitionChild>
        <div class="flex-shrink-0 px-4 flex items-center">
          <img src="@/assets/ChatPilot.png" class="h-24 w-auto">
        </div>
        <div class="mt-5 flex-1 h-0 px-2 overflow-y-auto">
          <nav class="h-full flex flex-col">
            <div class="space-y-1">
              <VLink v-for="item in navigationItems" :key="item.name" :href="item.href" activeClasses="fill-indigo-600 bg-indigo-200 text-indigo-600"  defaultClasses="text-gray-700 hover:bg-indigo-200 hover:text-indigo-600" class="relative group py-2 px-3 rounded-md flex items-center text-sm font-medium]">
                <component :is="item.icon" activeClasses="text-white" defaultClasses="text-indigo-300 group-hover:text-indigo-700" class="mr-3 h-6 w-6" aria-hidden="true" />
                <span>{{ $t(item.name) }}</span>
                <Counter v-if="item.isConversations && unreadConversationsCount > 0" v-bind:count="unreadConversationsCount" />
              </VLink>
            </div>
            <div v-if="agent" class="absolute bottom-5 left-0 text-center text-xs text-gray-600 flex-1 mt-6 w-full px-2 space-y-1">
              <div class="flex-1 mt-6 w-full px-2 space-y-1">
                <span class="font-bold text-xs mr-5 text-yellow-600" v-if="disconnected">
                  reconnecting
                  <svg class="animate-spin inline-block" xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
                      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <g>
                              <polygon points="0 0 24 0 24 24 0 24"/>
                          </g>
                          <path d="M12,4 L12,6 C8.6862915,6 6,8.6862915 6,12 C6,15.3137085 8.6862915,18 12,18 C15.3137085,18 18,15.3137085 18,12 C18,10.9603196 17.7360885,9.96126435 17.2402578,9.07513926 L18.9856052,8.09853149 C19.6473536,9.28117708 20,10.6161442 20,12 C20,16.418278 16.418278,20 12,20 C7.581722,20 4,16.418278 4,12 C4,7.581722 7.581722,4 12,4 Z" fill="#ffffff" fill-rule="nonzero" opacity="0.3" transform="translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) "/>
                      </g>
                  </svg>
                </span>
                <div class="text-center content-center"><AgentAvatar v-bind:agent="agent" class="inline-block" classes="text-center" plain="true" /></div>
                <div class="font-bold">{{agent.attributes.name}}</div>
                <div v-if="business">{{business.name}}</div>
                <div class="text-center"><a href="#" v-on:click="sendLogoutEvent" class="mt-4 flex align-middle justify-center items-center">
                  <span class="inline-block mr-1 flex-initial">{{ $t('actions.logout') }}</span>
                  <LogoutIcon class=" flex-initial h-5 w-5 inline-block float" />
                </a></div>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </TransitionChild>
    <div class="flex-shrink-0 w-14" aria-hidden="true">
      <!-- Dummy element to force sidebar to shrink to fit close icon -->
    </div>
  </div>
</template>
<script>
import VLink from './VLink.vue'
import Counter from './CounterWidget.vue'
import AgentAvatar from '../agents/AgentAvatar.vue'
import { LogoutIcon, XIcon } from '@heroicons/vue/outline'

import {
  DialogOverlay,
  TransitionChild,
  TransitionRoot,
} from '@headlessui/vue'

export default {
  name: 'SideBar',
  props: ['agent', 'business', 'unreadConversationsCount', 'disconnected', 'sidebarNavigation'],
  emits: ['logout-event', 'close-mobile-menu'],
  components: {
    VLink,
    Counter,
    AgentAvatar,
    //
    DialogOverlay,
    TransitionChild,
    TransitionRoot,
    LogoutIcon,
    XIcon,
  },
  computed: {
    navigationItems() {
      return this.sidebarNavigation.filter(element => {
        return element.beta && this.$root.Beta || !element.beta;
      })
    }
  },
  methods: {
    sendLogoutEvent() {
      this.$emit('logout-event');
    },
    sendCloseMobileMenuEvent() {
      this.$emit('close-mobile-menu');
    },
  },
}
</script>
